import { render, staticRenderFns } from "./RecordLinkMoreModal.vue?vue&type=template&id=076d7a41&scoped=true&"
import script from "./RecordLinkMoreModal.vue?vue&type=script&lang=js&"
export * from "./RecordLinkMoreModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordLinkMoreModal.vue?vue&type=style&index=0&id=076d7a41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d7a41",
  null
  
)

export default component.exports